




















































import Vue from 'vue'
import Component from 'vue-class-component'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { CartItem } from '../interfaces/product'

const BaseVue = Vue.extend({
  props: {
    showCart: Boolean
  },
  computed: {
    ...mapState(['cart']),
    ...mapGetters(['cartTotal', 'cartQuantity'])
  },
  methods: {
    ...mapMutations(['removeItem', 'updateItemQuantity'])
  }
})

@Component
export default class Cart extends BaseVue {
  formatPrice (price: number) {
    const formatter = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })

    return formatter.format(price)
  }

  onChangeVisibility ($event: any) {
    this.$emit('update:showCart', $event)
  }

  sendWhatsApp () {
    const encodedMessage = encodeURIComponent(
      'Resumen de su pedido:\n\n' +
      this.cart.map(({ _orig, quantity, fullSize }: CartItem) => {
        return `${quantity}x${_orig.Ref} - ${_orig.NombreCorto} - ${_orig.Color} - Talla: ${fullSize} ${this.formatPrice(_orig.Precio)} = ${this.formatPrice(_orig.Precio * quantity)}`
      }).join('\n') +
      `\n\nPara un total de ${this.formatPrice(this.cartTotal)}`
    )

    // Borrowed from: https://stackoverflow.com/a/11381730
    function detectMob () {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ]

      return toMatch.some(toMatchItem => navigator.userAgent.match(toMatchItem))
    }

    if (detectMob()) {
      window.open(`whatsapp://send?text=${encodedMessage}`)
    } else {
      window.open(`https://web.whatsapp.com/send?text=${encodedMessage}`)
    }
  }
}
